import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('updateQueryString')(function updateQueryString(
    recipientWell: FindControlViewState,
    queryString: string
) {
    recipientWell.queryString = queryString;
});
